<script setup>
import MaterialMark from '@/components/create/material/MaterialMark.vue';

const props = defineProps({
  asset: Object,
});

const emit = defineEmits(['click', 'remove']);

function removeAsset(asset) {
  emit('remove', asset);
}
</script>
<template>
  <div
    class="group relative inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-white transition-all duration-300"
  >
    <MaterialMark :asset="asset">
      <div class="flex items-center gap-2 cursor-pointer select-none">
        <!-- Image preview -->
        <div class="relative">
          <img
            :src="asset.url"
            class="w-6 h-6 object-cover rounded-lg shadow-sm ring-1 ring-white/50"
            :alt="$t('attach.material')"
          />
          <div
            class="absolute inset-0 rounded-lg bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"
          ></div>
        </div>

        <!-- Label -->
        <span class="text-slate-700 text-xs font-medium tracking-tight">
          {{
            $t('attach.asUsage', {
              usage: asset.tag || $t('attach.defaultUsage'),
            })
          }}
        </span>
      </div>
    </MaterialMark>

    <!-- Remove button -->
    <button
      @click="removeAsset(asset)"
      class="absolute -top-1 -right-1 w-5 h-5 bg-slate-800/90 hover:bg-red-500 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-200 opacity-0 group-hover:opacity-100 hover:scale-110"
      :title="$t('attach.remove')"
    >
      <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</template>
